import React from 'react';
import {TypeImplementation} from '@packages/systems/wfdl';
import {RiveSettingsOptions} from '@packages/systems/ui/shared-ui/Rive';
import {
  ContextualExpressions,
  stripAnn,
} from '@packages/utilities/contextual-expression';
import {useRiveContext} from './RiveContext';
import {getString} from '@packages/utilities/json';

export const artboard = TypeImplementation.Custom({
  render: function ArtboardInput({expr}) {
    const {artboards, selectArtboard, isInstanceReady} = useRiveContext();

    const literal = ContextualExpressions.getLiteral(stripAnn(expr));
    const state = literal ? getString(literal.value) : undefined;
    const validState = state && artboards.find(({name}) => name === state);

    return (
      <RiveSettingsOptions
        id="rive-artboard-input"
        label="Artboard"
        onChange={selectArtboard}
        value={
          isInstanceReady ? (validState ? validState.name : '') : (state ?? '')
        }
        isDisabled={!isInstanceReady}
        options={
          !isInstanceReady && state
            ? [{label: state, value: state}]
            : artboards.map(({name}) => ({
                label: name,
                value: name,
              }))
        }
      />
    );
  },
  system: {
    labelVariant: 'hidden',
    defaultValue: null,
  },
});
